import { apiClient } from './client'
import type { ValidateResponse, GenerateResponse, GenerateStatusResponse, DocumentResponse } from '../types'

export async function validateProject(id: string): Promise<ValidateResponse> {
  const { data } = await apiClient.post<ValidateResponse>(`/api/v1/generate/${id}/validate`)
  return data
}

export async function generateDocuments(id: string): Promise<GenerateResponse> {
  const { data } = await apiClient.post<GenerateResponse>(`/api/v1/generate/${id}/documents`)
  return data
}

export async function getStatus(id: string): Promise<GenerateStatusResponse> {
  const { data } = await apiClient.get<GenerateStatusResponse>(`/api/v1/generate/${id}/status`)
  return data
}

export async function listDocuments(id: string): Promise<DocumentResponse[]> {
  const { data } = await apiClient.get<DocumentResponse[]>(`/api/v1/documents/${id}`)
  return data
}

export async function downloadDocument(projectId: string, docType: string): Promise<Blob> {
  const { data } = await apiClient.get<Blob>(
    `/api/v1/documents/${projectId}/${docType}/download`,
    { responseType: 'blob' }
  )
  return data
}

export async function downloadZip(id: string): Promise<Blob> {
  const { data } = await apiClient.get<Blob>(`/api/v1/documents/${id}/zip`, { responseType: 'blob' })
  return data
}

export async function getPreviewHtml(id: string): Promise<string> {
  const { data } = await apiClient.get<string>(
    `/api/v1/generate/${id}/preview-html`,
    { responseType: 'text' }
  )
  return data
}
